document.addEventListener("DOMContentLoaded", (event) => {
  // Menu customization for heading click/view all integration
  document.querySelectorAll('.mega-menu__column').forEach(column => {
    const headingEl = column.querySelector('.mega-menu__column-heading');
    const viewAllLink = Array.from(column.querySelectorAll('.mega-menu__column-list-link'))
      .find(link => link.textContent.trim().toLowerCase() === 'view all');
  
    if (headingEl && viewAllLink) {
      const href = viewAllLink.getAttribute('href');
      const linkedHeading = document.createElement('a');
      linkedHeading.href = href;
      linkedHeading.className = headingEl.className;
      linkedHeading.textContent = headingEl.textContent.trim();
      headingEl.replaceWith(linkedHeading);
      /* REMOVING PER PF / 09.22.26 viewAllLink.closest('li').style.display = 'none'; */
    }
  });

  // Menu special styling/badgification for "NEW - "
  const newLinks = Array.from(document.querySelectorAll('a.mega-menu__column-list-link, .menu-drawer__mega-menu a')).filter(link =>
    link.textContent.trim().startsWith('NEW - ')
  );
  
  newLinks.forEach(link => {
    const fullText = link.textContent.trim();
    const restOfText = fullText.replace(/^NEW\s*-\s*/, '');

    link.style.fontFamily = "'Rift-Medium', sans-serif";
    // link.style.fontSize = '17.6px';

    link.innerHTML = ''; // Clear existing content

    const wrapperSpan = document.createElement('span');
    wrapperSpan.style.display = 'flex';
    wrapperSpan.style.alignItems = 'center';
    wrapperSpan.style.background = 'none';
    wrapperSpan.style.gap = '8px';

    const newSpan = document.createElement('span');
    newSpan.textContent = 'NEW';
    newSpan.style.color = '#FFFFFF';
    newSpan.style.background = '#007BB8';
    newSpan.style.fontFamily = 'Rift-Bold';
    newSpan.style.padding = '2px 8px';
    newSpan.style.borderRadius = '4px';
    newSpan.style.fontSize = '0.85em';
    newSpan.style.whiteSpace = 'nowrap';

    const textWrapper = document.createElement('span');
    textWrapper.classList.add('link-hover-line');
    textWrapper.textContent = restOfText;

    wrapperSpan.appendChild(newSpan);
    wrapperSpan.appendChild(textWrapper);
    link.appendChild(wrapperSpan);
  });
  
  // Swatch customization for images
  document.querySelectorAll('label.color-swatch').forEach((label) => {
    const style = label.getAttribute('style');
    const match = style.match(/--swatch-color:\s*((?:https?:\/\/|\/\/)[^\s;]+)/);
    if (match && match[1]) {
      const rawUrl = match[1];
      // console.log(rawUrl);
      label.style.setProperty('--swatch-color', `url(${rawUrl})`);
    }
  });

  // Run swatch updates for quickAdd / AJAX events
  const buttons = document.querySelectorAll('button[id^="quick-add"]');
  buttons.forEach(button => {
    button.addEventListener('click', () => {
      setTimeout(() => { waitForSwatches(document.querySelector('.quick-add-modal__content-wrapper')); }, 1000);
    });
  });

  /* const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && node.tagName.toLowerCase() === "quick-add-modal") {
          handleQuickAddModal(node);
        }
      }
    }
  });

  function handleQuickAddModal(modal) {
    waitForSwatches(modal);
  }

  observer.observe(document.body, { childList: true, subtree: true }); */

  // Swatch hover activating click() per AT for collections
  document.querySelectorAll("body.template-collection .js-color-swatches-wrapper").forEach((s) => {
    s.querySelectorAll(".js-color-swatches label").forEach((e) => {
      e.addEventListener("mouseenter", (event) => {
        e.click();
      });
    });
  });

  document.querySelectorAll("body.template-index .popular-products .js-color-swatches-wrapper").forEach((s) => {
    s.querySelectorAll(".js-color-swatches label").forEach((e) => {
      e.addEventListener("mouseenter", (event) => {
        e.click();
      });
    });
  });

  // Collection check for Swiper container
  const swiperContainer = document.querySelector('.featured-collections__swiper.swiper');

  if (swiperContainer && isDesktop()) {
    const swiperInstance = swiperContainer.swiper;

    if (swiperContainer.querySelectorAll('.swiper-slide').length >= 4) {
      swiperInstance.params.slidesPerView = swiperContainer.querySelectorAll('.swiper-slide').length;
      swiperInstance.update();
    }
  }
});

function waitForSwatches(modal, maxRetries = 30) {
  let tries = 0;

  const check = () => {
    const swatches = modal.querySelectorAll("label.color-swatch");

    if (swatches.length > 0) {
      console.log(`Found ${swatches.length} swatches in modal.`);

      swatches.forEach((t) => {
        const styleAttr = t.getAttribute("style");
        const match = styleAttr?.match(/--swatch-color:\s*(https?:\/\/[^\s;]+|\/\/[^\s;]+)/);

        if (match && match[1]) {
          let url = match[1];
          if (url.startsWith("//")) {
            url = window.location.protocol + url;
          }

          /* console.log("Swatch color image:", url); */
          t.style.setProperty("--swatch-color", `url(${url})`);
        }
      });
    } else if (tries < maxRetries) {
      tries++;
      requestAnimationFrame(check); // try again on next frame
    } else {
      console.warn("Swatches not found after max retries.");
    }
  };

  check();
}

/* For quantity discounts / JS Add */
function dbAddToCart(variantId, quantity) { 
  const quantityInput = document.querySelector('.quantity__input');
  if (quantityInput) {
    quantityInput.value = quantity;
    document.querySelector('.quantity__button[name="minus"]').classList.remove('disabled');
  }
  document.querySelector('.product-form__submit').click();
}

function isDesktop() {
  const minWidth = 999;
  const widthOk = window.matchMedia(`(min-width: ${minWidth}px)`).matches;

  const hasFinePointer = window.matchMedia('(pointer: fine)').matches;
  const noTouch = navigator.maxTouchPoints === 0;

  return widthOk && (hasFinePointer || noTouch);
}

(function () {
  var cache = {};
  var updateTokens = new WeakMap();

  function appendWidth(url, w) {
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function getViewAllHandle(container) {
    var links = container.querySelectorAll('.mega-menu__column-list-link');
    var viewAll = Array.prototype.filter.call(links, function (a) {
      return (a.getAttribute('aria-label') || '').trim() === 'View All';
    })[0] || links[links.length - 1];

    if (!viewAll) return null;
    var match = (viewAll.getAttribute('href') || '').match(/\/collections\/([a-z0-9-]+)/i);
    return match ? match[1] : null;
  }

  function fetchTopProduct(handle) {
    if (cache[handle]) return cache[handle];

    cache[handle] = fetch('/collections/' + handle + '/products.json?limit=1')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var product = data.products && data.products[0];
        if (!product) return null;

        var images = product.images || [];
        var image = images[1] || images[0];
        if (!image) return null;

        return {
          src: appendWidth(image.src, 600),
          alt: product.title,
          url: '/products/' + product.handle
        };
      })
      .catch(function () { return null; });

    return cache[handle];
  }

  function injectDesktopImage(column, product) {
    if (column.querySelector('.db-mega-menu-product-image')) return;
    var link = document.createElement('a');
    link.href = product.url;
    link.className = 'db-mega-menu-product-image';
    var img = document.createElement('img');
    img.src = product.src;
    img.alt = product.alt;
    img.loading = 'lazy';
    link.appendChild(img);
    column.appendChild(link);
  }

  function primeDesktopMenu(menuItem) {
    if (menuItem.dataset.dbMegaMenuPrimed) return;
    menuItem.dataset.dbMegaMenuPrimed = 'true';

    menuItem.querySelectorAll('.mega-menu__column').forEach(function (column) {
      var handle = getViewAllHandle(column);
      if (!handle) return;
      fetchTopProduct(handle).then(function (product) {
        if (product) injectDesktopImage(column, product);
      });
    });
  }

  document.querySelectorAll('li.list-menu--megamenu').forEach(function (menuItem) {
    menuItem.addEventListener('mouseenter', function () { primeDesktopMenu(menuItem); });
    menuItem.addEventListener('focusin', function () { primeDesktopMenu(menuItem); });
  });

  function updateCollectionsCard(tabsWrapper, tab, submenu) {
    var handle = getViewAllHandle(submenu);
    if (!handle) return;

    var label = (tab.textContent || '').trim();

    var menuScope = tabsWrapper.closest('.header__mega-menu') || tabsWrapper.parentElement;
    var card = menuScope && menuScope.querySelector('.mega-menu__collections .collection-card');
    if (card && card.offsetParent === null) card = null;

    var drawerScope = tabsWrapper.closest('.menu-drawer__submenu-inner') ||
                       tabsWrapper.closest('.menu-drawer__mega-menu') ||
                       menuScope;
    var navCard = drawerScope && drawerScope.querySelector('.nav-card');
    if (navCard && navCard.offsetParent === null) navCard = null;

    if (!card && !navCard) return;

    var token = (updateTokens.get(tabsWrapper) || 0) + 1;
    updateTokens.set(tabsWrapper, token);

    fetchTopProduct(handle).then(function (product) {
      if (!product) return;
      if (updateTokens.get(tabsWrapper) !== token) return;

      if (card) {
        var img = card.querySelector('.collection-card__image');
        var title = card.querySelector('.collection-card__title');
        var button = card.querySelector('.collection-card__button');
        if (img) {
          img.src = product.src;
          img.removeAttribute('srcset');
          img.alt = label || product.alt;
        }
        if (title && label) title.textContent = label;
        if (button) {
          button.href = '/collections/' + handle;
          if (label) button.textContent = 'Shop ' + label;
        }
      }

      if (navCard) {
        var navImg = navCard.querySelector('img');
        var navLink = navCard.querySelector('a');
        var navSpan = navCard.querySelector('span');
        if (navImg) {
          navImg.src = product.src;
          navImg.alt = label ? 'Shop ' + label : product.alt;
        }
        if (navLink) navLink.href = '/collections/' + handle;
        if (navSpan && label) navSpan.textContent = 'Shop ' + label;
      }
    });
  }

  function handleTabInteraction(event) {
    var tab = event.target.closest('.mega-menu__tab');
    if (!tab) return;

    var tabsWrapper = tab.closest('.js-mega-menu-mobile-tabs');
    if (!tabsWrapper) return;

    var tabId = tab.dataset.megaMenuTabId;
    var submenu = tabsWrapper.querySelector('.mega-menu__submenu[data-mega-menu-tab-id="' + tabId + '"]');
    if (submenu) updateCollectionsCard(tabsWrapper, tab, submenu);
  }

  document.addEventListener('click', handleTabInteraction, true);

  function initMobileCollectionsCards() {
    document.querySelectorAll('.js-mega-menu-mobile-tabs').forEach(function (tabsWrapper) {
      var initialTab = tabsWrapper.querySelector('.mega-menu__tab.mega-menu__tab--active') ||
                        tabsWrapper.querySelector('.mega-menu__tab');
      var initialSubmenu = tabsWrapper.querySelector('.mega-menu__submenu.mega-menu__submenu--active') ||
                            tabsWrapper.querySelector('.mega-menu__submenu');
      if (initialTab && initialSubmenu) updateCollectionsCard(tabsWrapper, initialTab, initialSubmenu);
    });
  }

  initMobileCollectionsCards();

  var mobileCollectionsCardsObserver = new MutationObserver(initMobileCollectionsCards);
  mobileCollectionsCardsObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['open']
  });
})();

/* ------------------------------------------------------------------
   DBI FIX — auto-select an available size when a color swap removes
   the currently selected size.

   Root cause: VariantSelects.updateMasterId() (assets/global.js) only
   sets this.currentVariant when every selected option matches a real
   variant exactly. If the color just clicked doesn't carry the size
   that was previously selected, no variant matches, and the page
   freezes on the old color/photo/price with Add to Cart stuck on
   "Unavailable" — even though the size grid correctly grays out the
   sizes that don't exist for the new color.

   Fix: after the native lookup comes back empty, fall back to the
   best variant for the color that was actually clicked (in-stock if
   one exists, otherwise the first size in that color's list) and
   reflect that pick in the size control, so the rest of the native
   flow (photo, price, URL, Add to Cart / Sold Out state) runs as
   normal off a real currentVariant.
   ------------------------------------------------------------------ */
document.addEventListener('DOMContentLoaded', function () {
  ['variant-radios', 'variant-selects'].forEach(function (tagName) {
    const Cls = customElements.get(tagName);
    if (!Cls || Cls.__dbFallbackPatched) return;
    Cls.__dbFallbackPatched = true;

    const originalUpdateMasterId = Cls.prototype.updateMasterId;

    Cls.prototype.updateMasterId = function () {
      originalUpdateMasterId.call(this);
      if (this.currentVariant) return; // exact match found, nothing to fix

      const data = this.getVariantData();
      const chosenColor = this.options[0]; // Color is always option1 on DBI/Flop apparel
      if (!chosenColor) return;

      const candidates = data.filter((v) => v.options[0] === chosenColor);
      if (!candidates.length) return;

      const fallback = candidates.find((v) => v.available) || candidates[0];
      this.currentVariant = fallback;

      const sizeValue = fallback.options[1];
      const sizeInput = [...this.querySelectorAll('input[type="radio"]')].find(
        (input) =>
          input.value === sizeValue && !input.closest('.product-form__controls--colors')
      );
      if (sizeInput && !sizeInput.checked) {
        sizeInput.checked = true;
      }
    };
  });
});